import type { EnergyProvider } from "./energyProvider";

/**
 * Links made by the affiliate tool (affiliate-tools, outside this repository), by supplier
 * id: `affiliateLinks.<country>.json`, rewritten by every run of the tool, so never edited
 * by hand. A supplier is only in it while a network has approved us; see affiliate/README.md.
 */
export type GeneratedLinks = Record<
  string,
  { url: string; network: string; campaign_id: string; campaign: string }
>;

/**
 * The suppliers with their affiliate link: the tool's, where it has one, else the plain `url`.
 * These files are the only source of tracking links (the providers files have none), so a
 * supplier whose programme stops loses its tracking link at the tool's next run.
 */
export function withGeneratedLinks<T extends EnergyProvider>(
  providers: T[],
  links: GeneratedLinks
): T[] {
  return providers.map((p) => ({ ...p, affiliateLink: links[p.id]?.url ?? p.url }));
}
